module.exports = __webpack_public_path__ + "img/service-tab-img5.fca03ac2.png";